import React from "react";
import { TableBody, TableCell, TableRow } from "@mui/material";

const ModelTaskTableBodyRow = ({
	columnCount,
	className,
	height,
	children,
	onClick,
}) => {
	if (!children && !height) return null;
	return (
		<TableBody>
			<TableRow style={height ? { height } : undefined}>
				<TableCell colSpan={columnCount} className={className} onClick={onClick}>
					{children}
				</TableCell>
			</TableRow>
		</TableBody>
	);
};

export default ModelTaskTableBodyRow;
